module.exports = __webpack_public_path__ + "img/tileset.7b9bdd4d.png";